import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import drop_down_icon from "../assets/icons/drop_down_icon.png";
import email_icon from "../assets/icons/email_icon.png";
import whatsapp_icon from "../assets/icons/whatsapp_icon.png";
import edit_pencil_icon from "../assets/icons/edit_pencil_icon.png";
import attachment_pin_icon from "../assets/icons/attachment_pin_icon.png";
import call_micro_icon from "../assets/icons/call_micro_icon.png";
import mail_micro_icon from "../assets/icons/mail_micro_icon.png";
import bag_micro_icon from "../assets/icons/bag_micro_icon.png";

const ExhibitionUserRedirectPage = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [inviteToggle, setInviteToggle] = useState(true);
  const [exhibitionToggle, setExhibitionToggle] = useState(true);
  const [contactToggle, setContactToggle] = useState(true);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const handleInviteToggle = () => {
    setInviteToggle(!inviteToggle);
  };

  const handleExhibitionToggle = () => {
    setExhibitionToggle(!exhibitionToggle);
  };

  const handleContactToggle = () => {
    setContactToggle(!contactToggle);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Tasks" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="flex justify-between">
        <div className="ml-4 w-[70%] exhibition-details">
          <div className="flex mt-4">
            <p className="text-[14px] mr-2">Exhibition Name 1</p>
            <div>
              <img src={drop_down_icon} alt="drop down" />
            </div>
          </div>

          <div className="mt-2">
            <p className="text-[14px]">Exhibition Name</p>
            <input
              type="text"
              placeholder="Exhibition Name 1"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>
          <div className="mt-2">
            <p className="text-[14px]">Start Date</p>
            <input
              type="text"
              placeholder="October 23, 2023"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>
          <div className="mt-2">
            <p className="text-[14px]">End Date</p>
            <input
              type="text"
              placeholder="October 25, 2023"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>
          <div className="mt-2">
            <p className="text-[14px]">Tags</p>
            <div className="border w-full p-2 rounded-lg  border-[#5EB0E7] text-[16px] flex">
              <div className="flex items-center justify-center text-[14px] border border-[#95C2FF] rounded-xl bg-[#D4F0FF] w-[10rem]">
                Traditional Wear{" "}
                <span className="text-[20px] ml-2">&#xd7;</span>
              </div>
              <div className="flex items-center justify-center text-[14px] border border-[#95C2FF] rounded-xl bg-[#D4F0FF] w-[10rem] ml-2">
                Indian Wear <span className="text-[20px] ml-2">&#xd7;</span>
              </div>
            </div>
          </div>

          <div className="mt-2">
            <p className="text-[14px]">Location</p>
            <input
              type="text"
              placeholder="Flat No. 302, Sunshine Apartments, Mahatma Gandhi Road, Mumbai, Maharashtra 400001,India"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>

          <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg">
            <div className="flex justify-between">
              <p className="text-[12px]">Invites</p>
              <div className="text-[12px]">
                <label className="blue-slider-toggle">
                  <input
                    type="checkbox"
                    checked={inviteToggle}
                    onChange={handleInviteToggle}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>

            {inviteToggle ? (
              <div className="mt-4 flex flex-col justify-between">
                <div className="flex w-full justify-between">
                  <div className="text-[#344054] border border-[#344054] text-[12px] bg-[#F2F4F7] w-[49%] flex justify-center items-center rounded-xl p-2">
                    <img src={email_icon} alt="email icon" className="mr-2" />
                    <p>Emails</p>
                  </div>
                  <div className="text-[#3485BB] border border-[#3485BB] text-[12px] bg-[#EFF8FF] w-[49%] flex justify-center items-center rounded-xl">
                    <img
                      src={whatsapp_icon}
                      alt="whatsapp icon"
                      className="mr-2"
                    />
                    <p>Whatsapp</p>
                    <span className="text-[20px] ml-2">&#xd7;</span>
                  </div>
                </div>

                <div className="bg-white mt-4 border p-4 rounded-lg">
                  <div className="flex justify-between">
                    <p className="text-[14px] font-bold">
                      Whatsapp invite message template
                    </p>
                    <img src={edit_pencil_icon} alt="edit" className="w-4" />
                  </div>
                  <p className="text-[#91929E] text-[12px] mt-2">
                    This is a dummy text message just to...
                  </p>
                  <div className="flex items-center mt-2">
                    <div>
                      <img
                        src={attachment_pin_icon}
                        className="w-10 cursor-pointer"
                        alt="attachment"
                      />
                    </div>
                    <div className="ml-2 text-[#828282] text-[12px]">
                      Attach for invite
                    </div>
                  </div>
                </div>
                <div className="text-center text-[#2F80ED] text-[14px] underline mt-2 cursor-pointer">
                  Share on social media
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="bg-[#F8F8F8] p-4 mt-4 rounded-lg ">
            <div className="flex justify-between">
              <p className="text-[12px]">Exhibition Cost</p>
              <div className="text-[12px]">
                <label className="blue-slider-toggle">
                  <input
                    type="checkbox"
                    checked={exhibitionToggle}
                    onChange={handleExhibitionToggle}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
            {exhibitionToggle ? (
              <div>
                <div className="bg-white p-3 mt-4 border rounded-lg">
                  <div className="flex justify-between">
                    <p className="text-[14px] font-bold">Rental Cost</p>
                    <img src={edit_pencil_icon} alt="edit" className="w-4" />
                  </div>
                  <p className="text-[#91929E] text-[12px] mt-2">
                    Budget: 70,000 max.
                  </p>
                </div>
                <div className="text-[14px] text-[#2F80ED] underline text-center mt-2">
                  +Add Other Expenses
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="bg-[#F8F8F8] p-4 my-4 rounded-lg">
            <div className="flex justify-between">
              <p className="text-[12px]">Contact Details</p>
              <div className="text-[12px]">
                <label className="blue-slider-toggle">
                  <input
                    type="checkbox"
                    checked={contactToggle}
                    onChange={handleContactToggle}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>

            {contactToggle ? (
              <div className="bg-white mb-4 p-3 mt-4 rounded-lg border">
                <div className="flex justify-between">
                  <p className="text-[14px] font-bold">Praveen Sharma</p>
                  <img src={edit_pencil_icon} alt="edit" className="w-4" />
                </div>
                <div className="text-[#828282] text-[12px] mt-2">
                  <div className="flex">
                    <img src={call_micro_icon} alt="phone icon" />
                    <p className="ml-1">+91-7856632923</p>
                  </div>
                  <div className="flex mt-2">
                    <img src={mail_micro_icon} alt="phone icon" />
                    <p className="ml-2">praveen@gmail.com</p>
                  </div>
                  <div className="flex mt-2">
                    <img src={bag_micro_icon} alt="phone icon" />
                    <p className="ml-1">Vendor</p>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExhibitionUserRedirectPage;
